var templates = require('../../ui/templates/article-caq.template');
var shared    = require('../../modules/shared');
var tracker   = require('./caq-viewport-tracker');

var CARD_GAP = 12; // px, matches commonlyaskedquestion.scss .carousel-track gap

/*
 * Wires the carousel behavior for one CAQ module: arrow/swipe navigation, slider
 * visibility, and repositioning on resize. All state is held in this closure so
 * multiple CAQ modules on one page operate independently.
 */
function initCaqCarousel(wrapper) {
    var carouselEl = wrapper.querySelector('.carousel');
    var trackEl    = wrapper.querySelector('.carousel-track');
    var leftSlider = wrapper.querySelector('.left-slider');
    var rightSlider = wrapper.querySelector('.right-slider');
    if (!carouselEl || !trackEl) {
        return;
    }

    var currentIndex = 0;

    function getCardWidth() {
        var firstCard = trackEl.querySelector('.card');
        return firstCard ? firstCard.offsetWidth : 0;
    }

    function getMaxIndex() {
        var carouselWidth = carouselEl.offsetWidth || 0;
        var trackWidth = trackEl.scrollWidth || 0;
        var step = getCardWidth() + CARD_GAP;
        if (step <= 0) {
            return 0;
        }
        var maxScroll = trackWidth - carouselWidth;
        return Math.max(0, Math.ceil(maxScroll / step));
    }

    function isMobile() {
        return window.innerWidth <= 767;
    }

    function updateSliders() {
        if (isMobile()) {
            if (leftSlider) { leftSlider.style.display = 'none'; }
            if (rightSlider) { rightSlider.style.display = 'none'; }
            return;
        }
        var maxIndex = getMaxIndex();
        if (leftSlider) { leftSlider.style.display = currentIndex > 0 ? '' : 'none'; }
        if (rightSlider) { rightSlider.style.display = currentIndex < maxIndex ? '' : 'none'; }
    }

    function slideTo(index) {
        var maxIndex = getMaxIndex();
        currentIndex = Math.max(0, Math.min(index, maxIndex));
        var offset = currentIndex * (getCardWidth() + CARD_GAP);
        trackEl.style.transform = 'translateX(-' + offset + 'px)';
        updateSliders();
    }

    // slideNext / slidePrev are only invoked by user gestures (arrow click or
    // swipe), so the analytics events live here (resize uses slideTo directly).
    function slideNext() {
        slideTo(currentIndex + 1);
        if (typeof window.wmdPageLink === 'function') {
            window.wmdPageLink('ar-caq_next');
        }
    }

    function slidePrev() {
        slideTo(currentIndex - 1);
        if (typeof window.wmdPageLink === 'function') {
            window.wmdPageLink('ar-caq_prev');
        }
    }

    if (rightSlider) {
        rightSlider.addEventListener('click', slideNext);
    }
    if (leftSlider) {
        leftSlider.addEventListener('click', slidePrev);
    }

    // Touch swipe
    var touchStartX = 0;
    var touchEndX = 0;
    var isSwiping = false;

    trackEl.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
        touchEndX = touchStartX;
        isSwiping = true;
    });
    trackEl.addEventListener('touchmove', function(e) {
        if (!isSwiping) { return; }
        touchEndX = e.changedTouches[0].screenX;
    });
    trackEl.addEventListener('touchend', function() {
        if (!isSwiping) { return; }
        isSwiping = false;
        var diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 50) {
            if (diff > 0) {
                slideNext();
            } else {
                slidePrev();
            }
        }
    });

    // Recalculate on resize (no analytics — not a user navigation)
    window.addEventListener('resize', function() {
        slideTo(currentIndex);
    });

    updateSliders();
}

/*
 * Wires "Read full answer" CTAs: open the Medscape AI layer with the card's
 * question. Routing through shared.handleSearch() means the anonymous 5-query gate
 * is applied automatically.
 */
function wireReadFullAnswer(wrapper) {
    wrapper.querySelectorAll('.cta').forEach(function(cta) {
        function openAnswer() {
            var question = cta.getAttribute('data-question');
            if (!question) { return; }
            if (typeof window.wmdPageLink === 'function') {
                window.wmdPageLink('ar-caq_readfull');
            }
            shared.handleSearch(question);
        }
        cta.addEventListener('click', openAnswer);
        cta.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                openAnswer();
            }
        });
    });
}

/*
 * Wires the "Ask your own question" input: Enter opens the AI layer with the
 * typed question.
 */
function wireAskYourOwnQuestion(wrapper) {
    var input = wrapper.querySelector('.ai-input-wrapper input');
    if (!input) { return; }
    input.addEventListener('keyup', function(e) {
        if (e.key !== 'Enter') { return; }
        var value = (input.value || '').trim();
        if (!value) { return; }
        if (typeof window.wmdPageLink === 'function') {
            window.wmdPageLink('ar-caq_ask');
        }
        shared.handleSearch(value);
        input.value = '';
    });
}

/*
 * Replaces the shimmer skeleton inside `wrapper` with the real CAQ carousel,
 * wires all interactions, fires the impression event, and starts viewport tracking.
 * Returns true on success.
 */
function renderCaqCarousel(cards, wrapper) {
    if (!cards || cards.length === 0 || !wrapper) {
        return false;
    }

    // Swap shimmer for real content.
    wrapper.classList.remove('loader');
    wrapper.innerHTML = templates.caqCarouselMarkup(cards);

    initCaqCarousel(wrapper);
    wireReadFullAnswer(wrapper);
    wireAskYourOwnQuestion(wrapper);

    // Module added to page
    if (typeof window.wmdPageLink === 'function') {
        window.wmdPageLink('ar-caq_imp');
    }

    // Module seen in viewport (fires once when 50% in view)
    tracker.observe(wrapper);

    return true;
}

module.exports = {
    renderCaqCarousel: renderCaqCarousel
};